import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { AGENT_HELP_ADDRESS } from "@consts/index";

import { RenewalDetails } from "./RenewalDetails";
import { PolicyDetailsContentProps } from "../../types";

export function PolicyRenewals({ policy, loading }: PolicyDetailsContentProps) {
  if (!policy && loading) {
    return <Skeleton height={114} variant="rounded" />;
  }

  if (policy && !policy?.renewals?.length) {
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          Policy was found but it has no renewals assigned. Please contact us
          via email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {[...policy.renewals]
        .sort(
          (
            { createdDate: renewalACreatedDate },
            { createdDate: renewalBCreatedDate }
          ) => renewalBCreatedDate.localeCompare(renewalACreatedDate)
        )
        .map((renewal) => (
          <RenewalDetails renewal={renewal} key={renewal.renewalLocator} />
        ))}
    </Grid>
  );
}
